import React, { useContext } from 'react';
import moment from 'moment';
import { type RestTwitterLaCard } from '@bbkAdminUtils/api-client/rest-la-cards-types';
import { cs } from '@bbkAdminUtils/css-utils';
import CustomerHtml from '@bbkFunnel/components/customer_html/customer_html';
import { FunnelContext } from '@bbkFunnelComponents/FunnelContext';
import { LossGridItem } from '@bbkFunnelComponents/loss/sections/grid-item';
import { LossTitle } from '@bbkFunnelComponents/loss/sections/title';
import { makeClassNameSafe } from '@bbkFunnelUtils/utils';

import './loss-twitter-card.scss';

const twitterIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 128 128"
  >
    <path
      fill="black"
      d="M86.8918 28.25H99.0219L72.5243 58.5334L103.698 99.75H79.285L60.1647 74.7536L38.2929 99.75H26.1627L54.5069 67.3565L24.5938 28.25H49.6199L66.9004 51.0974L86.8918 28.25ZM82.6337 92.4904H89.3555L45.9716 35.1301H38.7584L82.6337 92.4904Z"
    />
  </svg>
);

type Props = {
  card: RestTwitterLaCard;
  onClick?: () => void;
};

const LossTwitterCard: React.FC<Props> = ({
  card,
  card: {
    requires: { profile, tweet, title },
  },
  onClick,
}) => {
  // console.log('LossTwitterCard: ', props);
  const { isPreview } = useContext(FunnelContext);

  return (
    <LossGridItem
      classes={cs('la-twitter-card', makeClassNameSafe(card.name))}
      onClick={isPreview ? onClick : () => undefined}
    >
      <LossTitle>
        <CustomerHtml value={title} />
      </LossTitle>

      <div className="la-tc-profile">
        <div className="la-tc-p-pic">
          <img src={profile.pic} alt={profile.name} />
        </div>
        <div className="la-tc-p-user">
          <div className="la-tc-p-name">{profile.name}</div>
          <div className="la-tc-p-handle">@{profile.handle}</div>
        </div>
        <div className="twitter-icon">{twitterIcon}</div>
      </div>
      <div className="la-tc-content">{tweet.content}</div>
      <div className="la-tc-info">
        <div className="la-tc-t-date">{moment(tweet.date).format('MMM D')}</div>
        <div className="la-tc-t-link">
          <a
            href={tweet.link}
            target="_blank"
            rel="noreferrer"
            style={{
              color: 'inherit',
              fontSize: 'inherit',
              opacity: 'inherit',
              margin: '0px',
              padding: '0px',
              fontWeight: 'normal',
            }}
          >
            {tweet.linkText || 'Visit Tweet'}
          </a>
        </div>
      </div>
    </LossGridItem>
  );
};
export default LossTwitterCard;
